var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "social-store"
  }, [_c('div', {
    staticClass: "social-store-inner"
  }, [_c('h2', {
    staticClass: "title-store"
  }, [_vm._v("Мы всегда рядом")]), _c('h4', {
    staticClass: "text-store"
  }, [_vm._v("Финсайт скоро доступен на мобильных устройствах")]), _c('div', {
    staticClass: "markets-store"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/ruStore.svg"),
      "alt": "RuStore"
    }
  }), _c('img', {
    attrs: {
      "src": require("@/assets/img/google_play.svg"),
      "alt": "GooglePlay"
    }
  }), _c('img', {
    attrs: {
      "src": require("@/assets/img/appstore.svg"),
      "alt": "AppStore"
    }
  })])]), _c('picture', [_c('source', {
    attrs: {
      "srcset": require("@/assets/img/phone-store-mob.webp"),
      "alt": "phone",
      "media": "(max-width: 650px)"
    }
  }), _c('img', {
    staticClass: "phones-store",
    attrs: {
      "src": require("@/assets/img/phone-store.webp"),
      "alt": "phone"
    }
  })])])]);
}]

export { render, staticRenderFns }